import React, { forwardRef, useState, useMemo, useImperativeHandle } from 'react';
import { Form, Select, Spin, Empty } from 'antd';
import { useMutation } from '@apollo/client';

import { UPDATE_PROPERTY_PAYMENT_PLAN } from '../queries';
import { fetch } from '~helpers/graphql';
import * as queries from '~settings/queries';
import Modal from 'common/components/modal';
import BasicDetail from '../detail/basic';

import useStyles from './styles';

const SelectPaymentPlan = forwardRef(
  ({ t, loading, propertyId, paymentPlans, onChangeSuccess, property }, ref) => {
    const classes = useStyles();

    const [visible, setVisible] = useState(false);
    const [paymentPlanId, setPaymentPlanId] = useState(undefined);

    const currentPaymentPlan = useMemo(
      () => paymentPlans?.find(item => item.node.id === paymentPlanId),
      [paymentPlanId, paymentPlans],
    );

    const [updatePropertyPaymentPlan] = useMutation(UPDATE_PROPERTY_PAYMENT_PLAN, {
      variables: {
        input: {
          id: propertyId,
          paymentPlanId,
        },
      },
      onCompleted: result => {
        if (result.cmsUpdatePropertyPaymentPlan.success) {
          setVisible(false);

          fetch(queries.getPropertyDetail({ slug: property?.slug })).then(res => {
            if (res?.property) {
              onChangeSuccess?.(currentPaymentPlan?.node, res?.property);
            }
          });
        }
      },
    });

    const handleCloseModal = () => {
      setVisible(false);
    };

    const handleChangePaymentPlan = id => {
      setPaymentPlanId(id);
    };

    const handleConfirmClick = () => {
      updatePropertyPaymentPlan();
    };

    useImperativeHandle(ref, () => ({
      handleOpenModal: id => {
        setVisible(true);

        if (id) {
          setPaymentPlanId(id);
        }
      },
    }));
    const allowNoPayment = property?.landlord?.allowNoPayment;

    const filterPaymentOnlinePayment = paymentPlans?.filter(_item => _item?.node?.paymentOnline);
    const paymentPlansList = !allowNoPayment ? filterPaymentOnlinePayment : paymentPlans;
    console.log('[ paymentPlansList ] >', paymentPlansList);
    const findselectPayment = paymentPlansList?.find(
      _paymentPlan => _paymentPlan?.node?.id === paymentPlanId,
    )?.node?.name;

    return (
      <Modal
        title={t('cms:cms.property.listing_management.payment_plan.modal.title')}
        visible={visible}
        centered
        width={812}
        wrapClassName={classes.wrapper}
        cancelButtonProps={{
          className: classes.cancelButton,
        }}
        okText={t('cms:cms.global.modal.confirm.button')}
        okButtonProps={{
          className: classes.okButton,
        }}
        onOk={handleConfirmClick}
        onCancel={handleCloseModal}
      >
        <Choose>
          <When condition={loading}>
            <Spin />
          </When>
          <Otherwise>
            <Form className={classes.select}>
              <Form.Item label={t('cms:cms.property.listing_management.payment_plan.modal.select')}>
                <Select
                  placeholder={t(
                    'cms:cms.property.listing_management.payment_plan.modal.select.placeholder',
                  )}
                  onChange={handleChangePaymentPlan}
                  value={findselectPayment ? paymentPlanId : currentPaymentPlan?.node?.name}
                >
                  <For each="paymentPlan" of={paymentPlansList ?? []}>
                    <Select.Option value={paymentPlan?.node?.id}>
                      {paymentPlan?.node?.name}
                    </Select.Option>
                  </For>
                </Select>
              </Form.Item>
            </Form>

            <Choose>
              <When condition={paymentPlanId}>
                <BasicDetail t={t} paymentPlan={currentPaymentPlan?.node} property={property} />
              </When>
              <Otherwise>
                <div className={classes.emptyArea}>
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={t(
                      'cms:cms.property.listing_management.payment_plan.modal.empty_desc',
                    )}
                  />
                </div>
              </Otherwise>
            </Choose>
          </Otherwise>
        </Choose>
      </Modal>
    );
  },
);

export default SelectPaymentPlan;
